import { useState, useEffect } from 'react';
import { auth, db } from "../../firebase/config";
import uuid from 'react-uuid';
import firebase from '../../firebase/compat'
import { bucket } from '../../firebase/config';
import spinnerRipple from '../../images/spinner-ripple.svg'
import dummyPhoto from '../../images/Design/dummy-photo.jpeg'
import ScrollToTop from "../../hooks/ScrollToTop";
import Modal from 'react-modal';
import Location from '../../hooks/Location';
import spinner from '../../images/spinner-ripple.svg'
import buildUploadPath from '../../helpers/uploads/buildUploadPath';
import normalizeEmail from '../../helpers/normalizeEmail';
import registrationErrorMessage from '../../helpers/registrationErrorMessage';
import removeHalfCreatedAccount from '../../helpers/removeHalfCreatedAccount';

const Register = () => {

    const [email, setEmail] = useState("")
    const [password, setPassword] = useState("")
    const [passwordRepeat, setPasswordRepeat] = useState("")
    const [forname, setForname] = useState("")
    const [surname, setSurname] = useState("")
    const [photo, setPhoto] = useState(dummyPhoto)
    const [loader, setLoader] = useState("")
    const [communityNameDB, setCommunityNameDB] = useState("")
    const [modalOpen, setModalOpen] = useState(false);
    const [loading, setLoading] = useState(false)

    const id = uuid()
    ScrollToTop()
    Modal.setAppElement('#root');
    const location = Location()[1]

    const modalStyles = {
        content: {
          top: '50%',
          left: '50%',
          right: 'auto',
          bottom: 'auto',
          marginRight: '-50%',
          transform: 'translate(-50%, -50%)',
        },
      };
    
      useEffect(() => {
       
        db.collection("CompagnyMeta")
        .where("CompagnyID", "==", location)
        .get()
        .then((querySnapshot) => {
            querySnapshot.forEach((doc) => {
                setCommunityNameDB(doc.data().CommunityName)
            }
            )
        })
        .catch((error) => {
            console.log("Error getting documents: ", error);
        })
    }
    ,[location])


    const closeModal = () => {
        setModalOpen(false);
      }
    

    const fornameHandler = (e) => {
        const forname = e.target.value

        setForname(forname)
    }

    const surnameHandler = (e) => {
        const surname = e.target.value

        setSurname(surname)
    }

    const emailHandler = (e) => {
        const email = e.target.value

        setEmail(email)
    }

    const passwordHandler = (e) => {
        const password = e.target.value

        setPassword(password)
    }

    const passwordRepeatHandler = (e) => {
        const passwordRepeat = e.target.value

        setPasswordRepeat(passwordRepeat)
    }

    const photoHandler = (e) => {
        setLoader(spinnerRipple)

        const photo = e.target.files[0]

        // Uniek pad: een ruwe bestandsnaam laat twee mensen met dezelfde
        // 'foto.jpg' elkaars afbeelding overschrijven — anoniem, want deze
        // upload gebeurt deels vóór het inloggen.
        // AI-CONTEXT: See docs/inbox.md #122
        const storageRef = bucket.ref(buildUploadPath(photo.name, "ProfilePhotos"));
        const uploadTask = storageRef.put(photo)

        uploadTask.then(() => {
          
            uploadTask.on('state_changed', snapshot => {
            const progress = (snapshot.bytesTransferred / snapshot.totalBytes) * 100;
            switch (snapshot.state) {
            case firebase.storage.TaskState.PAUSED:
                console.log('Upload is paused');
                break;
            case firebase.storage.TaskState.RUNNING:
                console.log('Upload is running');
                break;
            }
            }, (err) => {
                alert(err)
            }, () => {
            uploadTask.snapshot.ref.getDownloadURL().then(downloadURL => {
            console.log('File available at', downloadURL);

            setPhoto(downloadURL)
            setLoader(downloadURL)

                })
            })
        }).catch((err) => {
            // Zonder deze afhandeling verdwijnt een geweigerde upload (te groot,
            // of tegengehouden door storage.rules) in een niet-afgevangen
            // belofte: geen melding, en de gebruiker ziet niets gebeuren.
            alert(`Uploaden mislukt: ${err?.message || err}`)
        })
    }

    const checkHandler = (e) => {
        e.preventDefault()

        if(password === passwordRepeat){
            registerHandler()
        } else {
            alert('De paswoorden zijn niet gelijk')
        }
    }

    const registerHandler = () => {

        setLoading(true)

        // Eén genormaliseerd adres voor het hele pad — zie docs/inbox.md Bug #137.
        const accountEmail = normalizeEmail(email)

        auth
        .createUserWithEmailAndPassword(accountEmail, password)
        .then(async (cred) => {

            const data = {
                email: accountEmail,
                forname: forname,
                surname: surname,
                photo: photo,
                uid: cred.user.uid,
                client: location,
                id: id,
                // Het webadres waar de aanmelder zat. De server heeft geen
                // adresbalk en kan het merk en de verificatielink er niet uit
                // afleiden; zonder dit veld valt de mail terug op Deccos.
                // AI-CONTEXT: See docs/pitfalls.md#dev-write-path-migration-drops-derived-values
                hostname: window.location.hostname,
            }

            // AI-CONTEXT: See docs/pitfalls.md#api-firebase-v1-region-default
            // createProfile is still v1 in us-central1 — the default client is
            // correct. The move to europe-west1 needs the function and a
            // production hosting release to ship together; see index.js.
            const createProfile = firebase.functions().httpsCallable('createProfile')

            try {
                const result = await createProfile({data: data})

                if(result.data !== 'success') {
                    throw new Error(`Er is iets mis gegaan, neem contact op met Deccos via info@deccos.nl`)
                }

                setLoading(false)
                setModalOpen(true)

            } catch (profileError) {
                // AI-CONTEXT: See docs/pitfalls.md#state-multi-step-signup-leaves-half-an-account
                // Inlogaccount zonder profiel: inloggen lukt dan wel, maar de
                // app weet niet wie je bent, en opnieuw registreren stuit op
                // "e-mailadres al in gebruik". Opruimen dus.
                await removeHalfCreatedAccount(cred.user)
                throw profileError
            }
        })
        .catch((error) => {
            setLoading(false)
            alert(registrationErrorMessage(error, normalizeEmail(email)))
        });
    }



    return (
        <div>
            <div className="login-container">
                <h2>Stap 2 van 2</h2>
                <h1>Creëer een persoonlijk account</h1>
                <p>Met je persoonlijke account kun je aan de slag in de omgeving van {communityNameDB}.</p>
                <form>
                    <p>Voornaam*</p>
                    <input onChange={fornameHandler} type="text" placeholder="Schrijf hier je voornaam" />
                    <p>Achternaam</p>
                    <input onChange={surnameHandler} type="text" placeholder="Schrijf hier je achternaam" />
                    <p>E-mailadres*</p>
                    <input onChange={emailHandler} type="email" placeholder="Schrijf hier je e-mailadres" />
                    <p>Wachtwoord*</p>
                    <input onChange={passwordHandler} type="password" placeholder="Schrijf hier je wachtwoord" />
                    <p>Herhaal je wachtwoord*</p>
                    <input onChange={passwordRepeatHandler} type="password" placeholder="Herhaal hier je wachtwoord" />
                    <p>Profielfoto</p>
                    <img src={photo} alt="" id='register-photo' />
                    <input onChange={photoHandler} type="file" />
                </form>
                <div className="button-container-register">
                    <button style={{display: loading ? 'none' : 'block'}} onClick={checkHandler}>Aanmelden</button>
                    <img style={{display: loading ? 'block' : 'none'}} src={spinner} alt="" />
                </div>
                <Modal
                isOpen={modalOpen}
                onRequestClose={closeModal}
                style={modalStyles}
                contentLabel="Verify account"
                >
                <div className='add-image-container'>
                    <h1>Welkom {forname} {surname}!</h1>
                    <h2>Je account is aangemaakt</h2>
                    <p>Je hoeft je account alleen nog te verifiëren. Er is een email gestuurd naar {normalizeEmail(email)} waarmee je je account kunt verifiëren. Je kunt deze pagina nu sluiten</p>
                </div>
                </Modal>
            </div>
        </div>
    )
}

export default Register
